// extracted by mini-css-extract-plugin
export default {"ScreenSMMin":"(min-width: 768px)","youGetOffer":"Gf31769","youGetOfferTitle":"G3e8ce5","rafGel":"G369fef","rafGelContent":"G9ee415","youGetLabel":"Gb5a9d4"};